export default __webpack_public_path__ + "static/beachday-e9fb3a7c6a0d66c9af3e2da16335e711.jpeg";